module.exports = __webpack_public_path__ + "static/teachersmutualbank-b8a594f0d1b4bdab91f3b48fe2d198ff.png";